import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./styles/llabaro.css";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Register the offline-shell service worker in production builds only (keeps dev HMR clean).
if ("serviceWorker" in navigator && import.meta.env.PROD) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch(() => {
      /* PWA install is a progressive enhancement — failure is non-fatal */
    });
  });
}
